import keyMirror = require('keymirror');

const status = keyMirror({
  APPROVED: null,
});

export {
  status,
};
